import { SearchField } from "@/common/components/search-field/SearchField";
import { useTranslation } from "@/translations";

interface Props {
  initialValue: string;
  onChange: (value: string | null) => void;
  width?: number | string;
}

export function ParticipantsSearch({ initialValue, onChange, width }: Props) {
  const { t } = useTranslation();

  return (
    <SearchField
      initialValue={initialValue}
      placeholder={t("proceedingParticipants.searchPlaceholder")}
      onChange={onChange}
      width={width}
    />
  );
}
